import { FC } from "react";
import { toDate, toDateTime, toMoney } from "../../../utils/formater";
import { Input } from "../../Input/Input";


type CellDataTableSubItemProps = {
  object: any,
  subitem: any,
  childrenPosition: number,
  textItem: string,
  indexHeader: number,
}

const CellDataTableSubItem:FC<CellDataTableSubItemProps> = ({
  object,
  childrenPosition,
  textItem,
  subitem,
  indexHeader,
}) => {
  return (
   <>
    <td
                    style={
                      indexHeader === 0
                        ? { paddingLeft: `10px !important`, minWidth: '10em' }
                        : { minWidth: '10em' }
                    }
                    className={`w-25 mx-2 d-flex align-items-center text-break ${indexHeader === 0 ? `px-${4 * childrenPosition}` : 'px-0'
                      }`}
                  >
                    {indexHeader === 0 && (
                      <span className='text-dark fw-thin me-2'>
                        {textItem.substring(0, textItem.length - 1)}
                      </span>
                    )}
                    {object.type === 'default' && (
                      <span className='text-dark fw-thin'>
                        {(subitem[object.value] && subitem[object.value].length) > 30
                          ? object.noLimit
                            ? subitem[object.value]
                            : `${subitem[object.value].substr(0, 30)}...`
                          : subitem[object.value]}
                      </span>
                    )}
                    {object.type === 'html' && (
                      <span className='text-dark fw-thin w-100'>
                        <div dangerouslySetInnerHTML={{ __html: `${subitem[object.value]}` }}></div>
                      </span>
                    )}
                    {object.type === 'money' && (
                      <span className='text-dark fw-thin'>{toMoney(subitem[object.value])}</span>
                    )}
                    {object.type === 'date' && (
                      <span className='text-dark fw-thin'>{toDate(subitem[object.value])}</span>
                    )}
                    {object.type === 'datetime' && (
                      <span className='text-dark fw-thin'>
                        {subitem[object.value] ? toDateTime(subitem[object.value]) : '-'}
                      </span>
                    )}
                    {object.type === 'image' && (
                      <>
                        {subitem[object.value] ? (
                          <a href={subitem[object.value]} target='_blank' rel='noopener noreferrer'>
                            <img
                              src={subitem[object.value]}
                              alt=''
                              style={{ objectFit: 'cover' }}
                              className='w-50px h-50px bg-light rounded'
                            />
                          </a>
                        ) : (
                          <img
                            src='https://placehold.co/150x150'
                            alt=''
                            style={{ objectFit: 'cover' }}
                            className='w-50px h-50px bg-light rounded'
                          />
                        )}
                      </>
                    )}
                    {object.type === 'checkBox' && (
                      <Input
                        value={subitem[object.value]}
                        checked={subitem[object.value]}
                        change={() => (object.action ? object.action(subitem) : {})}
                        inputAttr={{
                          type: 'checkbox',
                        }}
                        size={object.size}
                        disabled={object.disable}
                        checkSwift={false}
                      />
                    )}
                    {object.type === 'check' && (
                      <Input
                        value={subitem[object.value]}
                        checked={subitem[object.value]}
                        change={() => (object.action ? object.action(subitem) : {})}
                        inputAttr={{
                          type: 'checkbox',
                        }}
                        size={object.size}
                        disabled={object.disable}
                        checkSwift={true}
                      />
                    )}

                    {object.type === 'bullet' && (
                      <div className='d-flex align-items-center'>
                        <span className='w-5px h-30px rounded bg-secondary me-5'></span>
                        <span className='text-dark fw-thin'>{subitem[object.value]}</span>
                      </div>
                    )}
                    {object.type === 'badge' && object.badge && (
                      <span
                        className={`badge badge-light-${object.badge[subitem[object.value].toLowerCase()]
                          } fs-6 text-capitalize`}
                      >
                        {subitem[object.value]}
                      </span>
                    )}
                  </td>
   </>
  );
}


export {CellDataTableSubItem}